var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket_way_container"
  }, [_c('div', {
    staticClass: "container text-center color-ccc fs-30 empty-tip "
  }, [_vm._v(_vm._s(_vm.$t('public.ticketTips')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "@/assets/img/pubImg.png",
      "alt": ""
    }
  })])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e9c9a6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/ticketWay.vue
// module id = null
// module chunks = 